// Lightweight validators used in forms.

export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
export const ISO_COUNTRY_RE = /^[A-Z]{2}$/;

export function isEmail(s: string): boolean {
  return EMAIL_RE.test(s.trim());
}

export function isPassportNumber(s: string): boolean {
  // Loose: 5-15 alphanumeric (countries vary). Backend is the canonical check.
  return /^[A-Z0-9]{5,15}$/i.test(s.trim());
}

export function isCountryCode(s: string): boolean {
  return ISO_COUNTRY_RE.test(s.trim().toUpperCase());
}

export function isOtpCode(s: string, length = 6): boolean {
  return new RegExp(`^[0-9]{${length}}$`).test(s.trim());
}
